import { render, staticRenderFns } from "./CompanyBar.vue?vue&type=template&id=ef8afb5e&scoped=true&"
import script from "./CompanyBar.vue?vue&type=script&lang=js&"
export * from "./CompanyBar.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBar.vue?vue&type=style&index=0&id=ef8afb5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8afb5e",
  null
  
)

export default component.exports